import React, { useEffect, useState } from "react";

import styles from "./BoxModal.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { ClipLoader } from "react-spinners";

import { api } from "../../../api/api";

function Modal(props) {
  const { isEditing, boxId } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    length: 0,
    width: 0,
    height: 0,
    weight: 0,
    unit: "CM",
    weightUnit: "KG",
    position: 0,
    status: "active",
  });

  useEffect(() => {
    const fetchData = async () => {
      if (isEditing) {
        setIsLoading(true);
        const data = await api.get(`/boxes/getBox/${boxId}`);
        setData(data.data.box);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [isEditing, boxId]);

  return (
    <div className={styles.container}>
      <form onSubmit={props.onSubmit}>
        <div className={styles.heading}>
          <div></div>
          <h3> {isEditing ? "Update Box" : "Add New Box"}</h3>
          <FontAwesomeIcon
            style={{ cursor: "pointer" }}
            onClick={props.onClose}
            icon={faX}
          />
        </div>
        {isLoading && (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <ClipLoader
              className={styles.loadingSpinner}
              loading={isLoading}
              color="#fff"
              size={30}
            />
          </div>
        )}
        {!isLoading && (
          <div className={styles.formContent}>
            <div>
              <div className={styles.nameContainer}>
                <input
                  required
                  id="boxName"
                  type="text"
                  defaultValue={isEditing ? data.name : ""}
                  placeholder="Name"
                />
              </div>
            </div>
            <div className={styles.subContainer}>
              <div>
                <input
                  required
                  id="length"
                  type="number"
                  min="0"
                  defaultValue={isEditing ? data.length : ""}
                  placeholder="Length"
                />
              </div>
              <div>
                <input
                  required
                  id="height"
                  min="0"
                  type="number"
                  defaultValue={isEditing ? data.height : ""}
                  placeholder="Height"
                />
              </div>
              <div>
                <input
                  required
                  id="width"
                  min="0"
                  type="number"
                  defaultValue={isEditing ? data.width : ""}
                  placeholder="Width"
                />
              </div>
              <div>
                <input
                  required
                  id="weight"
                  min="0"
                  type="number"
                  defaultValue={isEditing ? data.weight : ""}
                  placeholder="Weight"
                />
              </div>
            </div>
            <div className={styles.subContainer}>
              <div>
                <select
                  required
                  id="units"
                  value="CM"
                  disabled
                  defaultValue={isEditing ? data.unit : null}
                >
                  <option value="" disabled selected hidden>
                    Unit
                  </option>
                  <option value="CM">CM</option>
                  <option value="M">M</option>
                </select>
              </div>
              <div>
                <select
                  required
                  id="weightUnit"
                  value="KG"
                  disabled
                  defaultValue={isEditing ? data.weightUnit : null}
                >
                  <option value="" disabled selected hidden>
                    Weight Unit
                  </option>
                  <option value="KG">KG</option>
                  <option value="Pounds">POUNDS</option>
                </select>
              </div>
              <div>
                <input
                  id="position"
                  min="0"
                  type="number"
                  defaultValue={isEditing ? data.position : ""}
                  placeholder="Position"
                />
              </div>
              <div>
                <select
                  required
                  id="status"
                  defaultValue={isEditing ? data.status : "active"}
                >
                  <option value="" disabled selected hidden>
                    Status
                  </option>
                  <option value="active">Active</option>
                  <option value="inactive">InActive</option>
                </select>
              </div>
            </div>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                columnGap: "5px",
              }}
            >
              <ClipLoader loading={props.isLoading} color="#fff" size={20} />
              {!isEditing ? "Add Box" : "Update Box"}
            </button>
          </div>
        )}
      </form>
    </div>
  );
}

export default Modal;
